import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900" data-id="element-995">
      <HeroSection data-id="element-996" />
      <PainSection data-id="element-997" />
      <TruthSection data-id="element-998" />
      <ProductPresentation data-id="element-999" />
      <ContentBreakdown data-id="element-1000" />
      <BenefitsSection data-id="element-1001" />
      <TestimonialsSection data-id="element-1002" />
      <ForYouSection data-id="element-1003" />
      <GuaranteeSection data-id="element-1004" />
      <BonusSection data-id="element-1005" />
      <ValueStack data-id="element-1006" />
      <FAQSection data-id="element-1007" />
      <ImpactPhrases data-id="element-1008" />
      <Footer data-id="element-1009" />
    </div>;
}